import React, { ReactElement, useState } from 'react';
import {
  EditPenIcon,
  PlusIcon,
} from '@trufla-technology/trumarket-react-design-system';
import './style.scss';

type Props<T> = {
  initialValue: T;
  onChange?: (value: T | undefined) => void;
  label: string;
  children: ReactElement;
  hideClear?: boolean;
};

export function NewEditableField<T>({
  initialValue,
  onChange,
  label,
  children,
  hideClear = false,
}: Props<T>) {
  const [isEditing, setIsEditing] = useState<boolean>(false);
  const [value, setValue] = useState<T | undefined>(initialValue);

  const handleChange = (updatedValue: T) => {
    if (!!!onChange) return;

    onChange(updatedValue);
    setValue(updatedValue);
    setIsEditing(false);
  };

  const handleOnKeyDown = (key: string) =>
    key === 'Enter' && value && setIsEditing(false);

  const EditComponent = React.cloneElement(children, {
    value: value,
    onChange: handleChange,
    onKeyDown: handleOnKeyDown,
    onBlur: () => setIsEditing(false),
    autoFocus: isEditing,
  });

  return isEditing ? (
    <div className="new-editable-field">{EditComponent}</div>
  ) : (
    <div
      className="editable-view-container"
      onDoubleClick={() => setIsEditing(true)}
    >
      <label>{label || '-'}</label>
      <div className="actions-wrapper">
        <span className="edit-icon" onClick={() => setIsEditing(true)}>
          <EditPenIcon />
        </span>
        {!hideClear && (
          <span
            className="remove-icon"
            onClick={() => {
              onChange?.(undefined);
              setValue(undefined);
            }}
          >
            <PlusIcon size="extra-small" />
          </span>
        )}
      </div>
    </div>
  );
}
